import "./Login.css";

import React, { useState } from "react";

import { useNavigate, Link } from "react-router-dom"; // For navigation
import { login } from "../utils/api"; // Import login function

function Login() {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    // Clear error when user starts typing
    if (error) {
      setError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    setLoginSuccess(false);
    
    try {
      await login(formData.email, formData.password);
      setLoading(false);
      setLoginSuccess(true);
      setTimeout(() => {
        navigate("/dashboard");
      }, 1000);
    } catch (error) {
      setLoading(false);
      setLoginSuccess(false);
      
      // Show the exact error from the backend so issues are visible
      setError(error.message || "An error occurred. Please try again.");
    }
  };

  return (
    <div className="login-page">
      {/* Top Navigation Bar */}
      <div className="top-nav">
        <div className="nav-content">
          <div className="nav-logo" onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
            <img src="/HDASLogo.png" alt="HDAS" style={{ height: "80px", width: "auto" }} />
          </div>
          <div className="nav-buttons">
            <button className="nav-button sign-in" onClick={() => navigate("/login")} style={{ opacity: 1 }}>
              Sign In
            </button>
            <button className="nav-button get-started" onClick={() => navigate("/register")}>
              Get Started
            </button>
          </div>
        </div>
      </div>

      <div className="login-container">
        <div className="login-form-container">
          <div className="tagline">Welcome Back</div>
          <h2>Sign into your account</h2>
          <p className="form-subtitle">Access your healthcare data analysis workspace</p>

          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label>Email address</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email address"
                required
              />
            </div>
            <div className="input-group">
              <label>Password</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Password"
                required
              />
            </div>
            <button type="submit" className="login-button" disabled={loading}>
              {loading ? "Logging in..." : "Login"}
            </button>
            
            {/* Error Message */}
            {error && (
              <div className="error-message">
                <span className="error-icon">!</span>
                <span className="error-text">{error}</span>
              </div>
            )}
            
            {/* Success Message */}
            {loginSuccess && (
              <div className="success-message">
                <span className="success-icon">OK</span>
                <span className="success-text">Login successful! Redirecting...</span>
              </div>
            )}
          </form>
          <div className="login-footer">
            <p>
              Don't have an account? <Link to="/register">Create one here</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;